// Invoice.js
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import logo from "../../image/heycourierLogo.png";
const InvoicePdf = forwardRef(({ data }, ref) => {
  if (!data) return null;

  return (
    <div
      ref={ref}
      style={{
        padding: "20px",
        background: "white",
        maxWidth: "800px",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
        wordWrap: "break-word",
      }}
    >
      {/* Logo and Company Info */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div>
          <img src={logo} alt="Hey Couriers Logo" style={{ height: "60px" }} />
        </div>
        <div
          style={{
            textAlign: "right",
            fontSize: "14px",
            wordBreak: "break-word",
            maxWidth: "100%",
          }}
        >
          <strong>THE BIG BOX GROUP PTY LTD T/A HEY COURIERS PTY LTD</strong>
          <br />
          <strong>ABN:</strong> {data.billed_by_abn}
          <br />
          {data.billed_by_email}
        </div>
      </div>

      {/* Invoice Metadata */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "30px",
          justifyContent: "flex-end",
          flexWrap: "wrap",
        }}
      >
        <div>
          <strong>Invoice Number</strong>
          <br />
          <div
            style={{
              border: "1px solid #ccc",
              padding: "5px 10px",
              minWidth: "150px",
              maxWidth: "250px",
              wordBreak: "break-word",
            }}
          >
            {data.invoice_number}
          </div>
        </div>
        <div>
          <strong>Invoice Date</strong>
          <br />
          <div
            style={{
              border: "1px solid #ccc",
              padding: "5px 10px",
              minWidth: "150px",
              maxWidth: "250px",
              wordBreak: "break-word",
            }}
          >
            {data.invoice_date}
          </div>
        </div>
        <div>
          <strong>Due Date</strong>
          <br />
          <div
            style={{
              border: "1px solid #ccc",
              padding: "5px 10px",
              minWidth: "150px",
              maxWidth: "250px",
              wordBreak: "break-word",
            }}
          >
            {data.due_date}
          </div>
        </div>
      </div>

      {/* From and To Info */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "30px",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <div
          style={{
            flex: "1 1 48%",
            border: "1px solid #eee",
            padding: "10px",
            backgroundColor: "#fafafa",
            minWidth: "280px",
          }}
        >
          <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px" }}>
            <strong>Invoice From</strong>
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              wordBreak: "break-word",
            }}
          >
            {data.billed_by_legal_name}
            <br />
            {data.billed_by_business_name}
            <br />
            {data.billed_by_address}
            <br />
            <strong>ABN:</strong> {data.billed_by_abn}
          </div>
        </div>
        <div
          style={{
            flex: "1 1 48%",
            border: "1px solid #eee",
            padding: "10px",
            backgroundColor: "#fafafa",
            minWidth: "280px",
          }}
        >
          <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px" }}>
            <strong>Invoice To</strong>
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              wordBreak: "break-word",
            }}
          >
            {data.invoice_to_name}
            <br />
            {data.invoice_to_address_line.split(",").map((line, index) => (
              <span key={index}>
                {line.trim()}
                <br />
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Invoice Table */}
      <table
        style={{
          width: "100%",
          marginTop: "30px",
          borderCollapse: "collapse",
          fontSize: "14px",
          tableLayout: "fixed",
        }}
        border="1"
      >
        <thead style={{ backgroundColor: "#f2f2f2" }}>
          <tr>
            <th style={{ padding: "8px" }}>Note</th>
            <th style={{ padding: "8px" }}>Quantity</th>
            <th style={{ padding: "8px" }}>Rate</th>
            <th style={{ padding: "8px" }}>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: "8px", wordBreak: "break-word" }}>
              {data.note}
            </td>
            <td style={{ padding: "8px" }}>{data.quantity}</td>
            <td style={{ padding: "8px" }}>${data.rate}</td>
            <td style={{ padding: "8px" }}>${data.sub_total}</td>
          </tr>
        </tbody>
      </table>

      {/* Totals */}
      <div style={{ textAlign: "right", marginTop: "20px", fontSize: "14px" }}>
        <div>Total Amount: ${data.total_amount_without_gst}</div>
        <div>GST 10%: ${data.gst}</div>
        <div>
          <strong>Amount Due: ${data.total_amount_with_gst}</strong>
        </div>
      </div>

      {/* Bank Info */}
      <div
        style={{ marginTop: "30px", fontSize: "14px", wordBreak: "break-word" }}
      >
        <strong>Bank Info</strong>
        <br />
        THE BIG BOX GROUP PTY LTD
        <br />
        Account No: {data.account_no}
        <br />
        BSB: {data.bank_state_branch}
      </div>

      <div
        style={{
          textAlign: "right",
          marginTop: "30px",
          fontWeight: "bold",
          color: "orange",
          fontSize: "16px",
        }}
      >
        Thank You!
      </div>
    </div>
  );
});

InvoicePdf.propTypes = {
  data: PropTypes.shape({
    billed_by_legal_name: PropTypes.string,
    billed_by_business_name: PropTypes.string,
    billed_by_address: PropTypes.string,
    billed_by_abn: PropTypes.string,
    billed_by_email: PropTypes.string,
    invoice_to_name: PropTypes.string,
    invoice_to_address_line: PropTypes.string,
    invoice_number: PropTypes.string,
    invoice_date: PropTypes.string,
    due_date: PropTypes.string,
    note: PropTypes.string,
    quantity: PropTypes.number,
    rate: PropTypes.string,
    sub_total: PropTypes.string,
    total_amount_without_gst: PropTypes.string,
    gst: PropTypes.string,
    total_amount_with_gst: PropTypes.string,
    account_no: PropTypes.string,
    bank_state_branch: PropTypes.string,
  }).isRequired,
};
InvoicePdf.displayName = "InvoicePdf";
export default InvoicePdf;
